
import { Component, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../shared/services/language.services';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'home-page',
    styleUrls: [
        './homepage.component.scss'
    ],
    templateUrl: './homepage.component.html',
    imports: [
    RouterModule,
    TranslateModule,
    CommonModule
],
    providers: [LanguageService]
})
export class HomePageComponent implements OnInit {
  consent!: boolean;
  displayModal: boolean = false;
  currentLanguage: string = 'en';
  languageDescription: string = 'English';
  openLanguageMenu = false;
  private languageService = inject(LanguageService);
  private translateService = inject(TranslateService);
  private host = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    this.checkConsent();
    this.currentLanguage = this.normalizeLanguage(this.languageService.getLanguage());
    this.setLanguageDescription(this.currentLanguage);
  }

  checkConsent(): void {
    this.consent = localStorage.getItem('consent') === 'true';
    if (!this.consent) {
      this.openModal();
    }
  }

  openModal() {
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
    this.handleConsent();
  }

  handleConsent(): void {
    localStorage.setItem('consent', 'true');
  }

  handleWithdrawal(): void {
    localStorage.setItem('consent', 'false');
  }

  useLanguage(language: string): void {
    this.translateService.use(language);
    this.translateService.setDefaultLang(language);
    localStorage.setItem('language', language);
    this.currentLanguage = language;
    this.setLanguageDescription(language);
    this.closeLanguageMenu();
    window.location.reload();
  }

  private normalizeLanguage(language: string | null): string {
    if (!language) {
      return 'en';
    }
    if (language === 'en-US') {
      return 'en';
    }
    if (language === 'pt') {
      return 'pt-PT';
    }
    return language;
  }

  toggleLanguageMenu(): void {
    this.openLanguageMenu = !this.openLanguageMenu;
  }

  closeLanguageMenu(): void {
    this.openLanguageMenu = false;
  }

  setLanguageDescription(language: string): void {
    switch (language) {
      case 'pt-BR':
        this.languageDescription = 'Portuguese (BR)';
        break;
      case 'pt-PT':
        this.languageDescription = 'Portuguese (PT)';
        break;
      default:
        this.languageDescription = 'English';
    }
  }

  getLanguageFlag(language: string): string {
    const currentLanguage = language || this.currentLanguage || 'en';
    switch (currentLanguage) {
      case 'pt-BR':
        return 'fi fi-br';
      case 'pt-PT':
        return 'fi fi-pt';
      default:
        return 'fi fi-us';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.openLanguageMenu) {
      return;
    }
    const target = event.target as Node | null;
    if (target && !this.host.nativeElement.contains(target)) {
      this.closeLanguageMenu();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    this.closeLanguageMenu();
  }
}
